import {useSelector} from 'react-redux'
import {useLocation} from 'react-router-dom'
import queryString from 'query-string'
import {isAdminSelector} from '../../utils'
import {Container, StartProcedureCard} from 'features/procedures/StartProcedureCard'

const ChooseAddOrRemove = () => {
  const {search, pathname} = useLocation()
  const {isAdmin, currentUserEmployeeId} = useSelector((state) => ({
    isAdmin: isAdminSelector(state),
    currentUserEmployeeId: state.session.currentUser.employee?.id,
  }))

  const isEmployeeInput = !isAdmin || pathname.includes('/mypage/')
  const employeeId = isAdmin ? queryString.parse(search).employee_id : currentUserEmployeeId

  return (
    <>
      <div className="l-title-wrap">
        <h1 className="m-title-main">変更の種類を選択</h1>
        <p className="m-title-main-note">変更の種類を選んでください</p>
      </div>
      <Container>
        <StartProcedureCard
          to={
            isEmployeeInput
              ? `/mypage/add_dependents/choose_new_or_exists`
              : `/add_dependents/choose_new_or_exists?employee_id=${employeeId}`
          }
          variant="next"
        >
          家族情報の追加
        </StartProcedureCard>
        <StartProcedureCard
          to={
            isEmployeeInput
              ? '/mypage/remove_dependents/choose_dependents'
              : `/remove_dependents/choose_dependents?employee_id=${employeeId}`
          }
          variant="start"
        >
          家族情報の削除
        </StartProcedureCard>
      </Container>
    </>
  )
}

export default ChooseAddOrRemove
